import React from "react";
import {
    Card, CardActions, CardContent, CardHeader,
    Divider, Button
} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(33, 33, 33, 0.45)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        position: 'relative',
        outline: 'none',
        boxShadow: theme.shadows[20],
        maxHeight: '100%',
        overflowY: 'auto',
        maxWidth: '100%',
        minWidth: 400,
        background: '#fff',
    },
    header: {
        color: '#d32f2f',
        fontWeight: 600,
    },
    actions: {
        justifyContent: 'flex-end'
    },
    domainList: {
        marginTop: 8,
        fontWeight: 600,
        color: '#d32f2f',
    },
}));

const BlackListDomainModal = ({ blackListDomains = [], onClose }) => {
    const classes = useStyles();

    return (
        <div className={classes.overlay}>
            <Card className={clsx(classes.root)}>
                <CardHeader
                    className={classes.header}
                    title="Domain is blacklisted"
                />
                <Divider />
                <CardContent>
                    <div>This email domain is blacklisted for the associated firm(s) and cannot be used.</div>
                    {blackListDomains.length > 0 && (
                        <div className={classes.domainList}>
                            Blacklisted domain(s): {blackListDomains.join(', ')}
                        </div>
                    )}
                    <div style={{ marginTop: 12 }}>Please use a different email address.</div>
                </CardContent>
                <Divider />
                <CardActions className={classes.actions}>
                    <Button onClick={onClose} color="secondary" variant="contained">Close</Button>
                </CardActions>
            </Card>
        </div>
    );
};

export default BlackListDomainModal;

